var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"centerMap"}},[_c('div',{staticClass:"centerMapContainer"},[_c('div',{ref:"echartMap",staticClass:"echartMap",attrs:{"id":"echartMap"}}),_c('div',{staticClass:"areaBox"},[_c('CenterArea',{attrs:{"rateList":_vm.billboardList}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }